import { useDatabase } from "@nozbe/watermelondb/hooks";
import React from "react";
import { TextPropTypes, Text } from "@towersystems/roam-common-native";
import Supplier from "../../utilities/data/model/Supplier";

const UNKNOWN_SUPPLIER = "Unknown Supplier";

export type SupplierIdToNameProps = TextPropTypes & {
  supplierId: string;
};

export const SupplierIdToName = ({
  supplierId,
  ...props
}: SupplierIdToNameProps) => {
  const [name, setName] = React.useState<string | undefined>(undefined);
  const database = useDatabase();

  React.useEffect(() => {
    (async () => {
      try {
        const supplier = await database
          .get<Supplier>("suppliers")
          .find(supplierId);

        setName(supplier.name ?? UNKNOWN_SUPPLIER);
      } catch (err) {
        setName(UNKNOWN_SUPPLIER);
      }
    })();
  }, [supplierId]);

  if (!name) {
    return null;
  }

  return <Text {...props}>{name}</Text>;
};
